import React from "react";

export const Page403: React.FC = () => {
  return <>403</>;
};
export default React.memo(Page403);
